Profile = new (function () {
  this.bindEvents = () => {
    $(document).on(
      "change",
      "#promotional_alerts_accepted, #colour_blind_theme",
      function () {
        if (!$(".preferences_wrapper").find($(this)).length) {
          return;
        }

        var params = {};

        params[$(this).attr("name")] = $(this).is(":checked");

        $.ajax({
          type: "PATCH",
          url: "/profile/preferences",
          data: JSON.stringify({ preferences: params }),
          contentType: "application/json",
          dataType: "json",
        })
          .done(() => Shared.showSnackbar({ text: CONSTANTS.ALERTS.SUCCESS }))
          .fail((err) =>
            Shared.showSnackbar({ type: CONSTANTS.ALERT_TYPES.error, text: err.responseText || err.statusText })
          );
      }
    );
  };
})();
